import { useState, useRef } from 'react'
import { Button, List, Col, Row } from 'antd'
import InputField from "./InputField"
import { WHITE, BUBBLE_BGND } from "../../styles/styleUtils"
import { useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"
import getData from './GetData'
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { useDispatch } from "react-redux"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import CenteredPopup from './CenteredPopup'
import parse from 'html-react-parser'

//=======================================
// Name number list component Version 1.0
//=======================================

const NameNumberListComponent = ({ namePattern, numberPattern, nameNumber, setNameNumber, ACDprefix }) => {

    const [errorAdd, setErrorAdd] = useState(true);
    const [resetFields, setResetFields] = useState(0); // Dummy counter for network to force redraw

    const name = useRef();
    const number = useRef();
    const creationAllowed = useRef(); // Used to check if RSI value can be created
    const creationError = useRef(); // Used to display the creation error cause 

    // Selection
    const [selectedItem, setSelectedItem] = useState(null);

    // Informative popup
    const parentRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState("");

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);
    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    // List management
    const addEntryInList = (value) => {
        setNameNumber(draft => {
            draft.push(value);
        });
        setResetFields(resetFields + 1);
    }

    const removeFromList = () => {
        if (selectedItem) {
            //setData(data.filter(i => i !== selectedItem));
            setNameNumber(nameNumber.filter(i => (i.Local_Number !== selectedItem.Local_Number) || (i.CCDn_Name !== selectedItem.CCDn_Name)));
            setSelectedItem(null);
        }
    };

    // Check if duplicate in the buffer
    const checkDuplicate = (local_number) => {
        return nameNumber.some(item =>
            item.Local_Number === local_number);
    }

    // Edit fields handlers
    const updateName = (value) => {
        name.current = value;
        if ((value !== "") && (value !== undefined) && (number.current !== "") && (number.current !== undefined)) {
            setErrorAdd(false); // no error
        }
        else {
            setErrorAdd(true); // Value not yet defined
        }
        setSelectedItem(null);
    }

    const updateNumber = (value) => {
        number.current = value;
        if (value && name.current) {
            setErrorAdd(false); // no error
        }
        else {
            setErrorAdd(true); // Value not yet defined
        }
        setSelectedItem(null);
    }

    // Handler to display the values in the list
    const displayItem = (value) => {
        let str;

        str = value.CCDn_Name + "\t" + value.Local_Number;

        return str;
    }

    // Handler to select an item in the list
    const handleSelect = (item) => {
        setSelectedItem(item);
    };

    // Add parameter in the list
    const addEntry = async () => {
        let obj = { "CCDn_Name": name.current, "Local_Number": number.current };

        creationAllowed.current = null;
        creationError.current = null;

        if (!checkDuplicate(number.current)) {

            // Verify if the range is configurable in OXE
            await checkRSIConfiguration();

            if (creationAllowed.current === true) {
                addEntryInList(obj);
            }
            else {
                showPopup("VALUE_NOT_CONFIGURABLE");
            }

            // Reset the value for next check
            creationAllowed.current = null;
        }
        else { 
            // Duplicate error
            showPopup("DUPLICATE_VALUE");
        }
        setErrorAdd(true);
        setSelectedItem(null);
    }

    // Test against backend if the configuration can be created

    const rsiHandler = (data) => {
        creationAllowed.current = data[0]?.creationPossible;
        creationError.current = data[0]?.errorCause;
    }

    const checkRSIConfiguration = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-rsi-acd-prefix-creation/" + nodeNumber + "/" + ccproductid + "/" + number.current + "/" + ACDprefix;

            dispatch(setContentLoading(true));
            response = await getData(url, null, rsiHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }
    
    // Informative popup 
    const showPopup = (msg) => {
        setMessage(parse(getTranslated(dict, msg) + (creationError.current ? "<br/>" + creationError.current : "")));
        setVisible(true);
        setTimeout(() => setVisible(false), 3000); // Hide after 3 seconds
    };

    return (<div className="namenb-style">
        <div className={"namenb"}>
            <div className="namenb-fields">
                <InputField label={getTranslated(dict, "PARAM_RSI_NAME")}
                    regexp={namePattern ?? ".{1,16}"}
                    handleChange={updateName}
                    reset={resetFields}
                    />
                <InputField label={getTranslated(dict, "PARAM_RSI_NUMBER")}
                    regexp={numberPattern ?? "[0-9A-D*#T]{1,8}"}
                    handleChange={updateNumber}
                    reset={resetFields}
                    />
            </div>
        </div>
        <div className="action" ref={parentRef}>
            <Button className="add-style" disabled={errorAdd} onClick={addEntry}>{getTranslated(dict, "LABEL_ADD")}</Button>
            <Button className="remove-style" disabled={!selectedItem} onClick={removeFromList}>{getTranslated(dict, "LABEL_REMOVE")}</Button>
        </div>
        <div className="list" >
            <List className="list-format"
                size="small"
                bordered
                dataSource={nameNumber}

                renderItem={(item) => (
                    <List.Item
                        key={item.id ?? item.name} // ensure a unique key
                        style={{
                            backgroundColor: item === selectedItem ? BUBBLE_BGND : WHITE,
                            cursor: 'pointer',
                        }}
                        onClick={() => handleSelect(item)}
                        >
                        <Row style={{ width: '100%', height: '24px', color: 'black' }} gutter={8} wrap={false}>
                            <Col flex="auto">{item.CCDn_Name}</Col>
                            <Col flex="120px" style={{ textAlign: 'right' }}>
                            {item.Local_Number}
                            </Col>
                        </Row>
                    </List.Item>
                )}>


            </List>
        </div>
        <CenteredPopup parentRef={parentRef} visible={visible} message={message} />
    </div>);
}

export default NameNumberListComponent;
